import { ReactNode } from "react";
import { titleCase } from "title-case";
import { Box } from "~/components-styled/box";
import { Collapsible } from "~/components-styled/collapsible";
import { Paragraph } from "~/components-styled/typography";
import { useSendCategorizedEvent } from "~/lib/analytics";

interface ContentCollapsibleProps {
  title: string;
  description: string;
  children: ReactNode;
}

export function ContentCollapsible({
  title,
  description,
  children,
}: ContentCollapsibleProps) {
  const sendEvent = useSendCategorizedEvent({
    action: "Features: Expand",
    label: title,
  });

  return (
    <Collapsible
      onOpenChange={(isOpen) => isOpen && sendEvent()}
      trigger={
        <Box spacing="y2">
          <Paragraph variant="subtitle1">{titleCase(title)}</Paragraph>
          <Paragraph variant="body1" css={{ color: "$blueGray" }}>
            {description}
          </Paragraph>
        </Box>
      }
    >
      <Box
        css={{
          spacingLayout: "copy",
          text: "body1",
          pt: "$3",
          "@md": { pt: "$4" },
        }}
      >
        {children}
      </Box>
    </Collapsible>
  );
}
